import localStorageService from '@/services/localStorage'
import { yellow } from '@/components/Analytics/common/theme.js'
import { getDeepProperty } from '@/helpers/deepObject.js'
import {
  getSinceRelease
} from '@/scenes/Audience/util/helpers.js'

const storageKey = (id) => `audience-global-defaults-v3-${id}`

export const episodeDefault = (id) => {
  const sessionState = localStorageService.getObject(storageKey(id))
  return getDeepProperty(sessionState, 'episode') || {id: 'all'}
}

export const episodesDefault = (id) => {
  const sessionState = localStorageService.getObject(storageKey(id))
  return getDeepProperty(sessionState, 'episodes') || []
}

export const podcastDefault = (id) => {
  const sessionState = localStorageService.getObject(storageKey(id))
  return getDeepProperty(sessionState, 'podcast') || []
}

export const podcastsDefault = (id) => {
  const sessionState = localStorageService.getObject(storageKey(id))
  return getDeepProperty(sessionState, 'podcasts') || { id: 'all' }
}

export const networkDefault = (id) => {
  const sessionState = localStorageService.getObject(storageKey(id))
  return getDeepProperty(sessionState, 'network') || {id: 'all'}
}

export const networksDefault = (id) => {
  const sessionState = localStorageService.getObject(storageKey(id))
  return getDeepProperty(sessionState, 'networks') || []
}

export const campaignDefault = (id) => {
  const sessionState = localStorageService.getObject(storageKey(id))
  return getDeepProperty(sessionState, 'campaign') || {id: null}
}

export const timeframeDefault = (id) => {
  const sessionState = localStorageService.getObject(storageKey(id))
  if (!getDeepProperty(sessionState, 'timeframe')) {
    return {
      start: null,
      end: null,
      notLoaded: null
    }
  }
  return sessionState.timeframe
}

export const timestampDefault = (id) => {
  const sessionState = localStorageService.getObject(storageKey(id))
  return getDeepProperty(sessionState, 'timestamp') || null
}

export const themeDefault = (id) => {
  const sessionState = localStorageService.getObject(storageKey(id))
  return getDeepProperty(sessionState, 'theme') || yellow
}

export const saveToSession = (state) => {
  localStorageService.setObject(storageKey(state.id), {
    ...state
  })
}

export const getAnalyticsOptions = (rootState, rootGetters, accountCompare, compareMultiple = false) => {
  let options = {
    timeframe: rootState.audience.timeframe,
    release: getSinceRelease(rootState.audience.timestamp)
  }

  if (accountCompare) {
    options.account = rootGetters.currentAccount.id
    if (compareMultiple) {
      if (rootState.audience.podcasts.length > 0) {
        options.podcasts = rootState.audience.podcasts.map(podcast => podcast.id)
      } else if (rootState.audience.networks.length > 0) {
        options.networks = rootState.audience.networks.map(network => network.id)
      }
    } else if (rootState.audience.podcast.id !== 'all') {
      options.podcast = rootState.audience.podcast.id
    } else if (rootState.audience.network.id !== 'all') {
      options.network = rootState.audience.network.id
    }
  } else {
    if (compareMultiple) {
      if (rootState.episodes.length > 0) {
        options.episodes = rootState.audience.episodes.map(episode => episode.id)
      }
    } else if (rootState.audience.episode.id !== 'all') {
      options.episode = rootState.audience.episode.id
    } else {
      options.podcast = rootGetters.activePodcastId
    }
  }
  return options
}

export default {
  episodeDefault,
  episodesDefault,
  podcastDefault,
  podcastsDefault,
  networkDefault,
  networksDefault,
  campaignDefault,
  timeframeDefault,
  timestampDefault,
  themeDefault,
  saveToSession,
  getAnalyticsOptions
}
